import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { CommunityAutonomous, CommunityAutonomousResponse } from '@/api/communityAutonomous.api';

interface CommunityAutonomousStore {
	dataCommunities: CommunityAutonomous[];
	total: number;
	message: string;
	setCommunityData: (data: CommunityAutonomousResponse) => void;
	clearCommunityData: () => void;
	getCommunityData: () => CommunityAutonomousResponse;
}

export const useCommunityAutonomousStore = create<CommunityAutonomousStore>()(
	persist(
		(set, get) => ({
			dataCommunities: [],
			total: 0,
			message: '',
			setCommunityData: (data: CommunityAutonomousResponse) =>
				set({
					dataCommunities: data.communities,
					total: data.total,
					message: data.message,
				}),
			clearCommunityData: () =>
				set({
					dataCommunities: [],
					total: 0,
					message: '',
				}),
			getCommunityData: () => ({
				communities: get().dataCommunities,
				total: get().total,
				message: get().message,
			}),
		}),
		{ name: 'community-autonomous-store' },
	),
);
